import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import Renderable from '../../../Component/Renderable';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';

export default function PlusStreakCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const targetCards = taskData.cards.map((targetCardID: string) =>
        system.getCardByID(targetCardID)
    );
    targetCards.forEach((card) => {
        card.getComponent(Renderable).visible = false;
    });

    const plusStreakAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(plusStreakAnimator);

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardPlusStreak',
        plusStreakAnimator,
        {
            scene: system.scene,
            targetCards: targetCards,
            stackContainer: system.stackContainer,
        },
        true
    );
    task.animationClip.on('PlusStreakCardAdded', (card, i) => {
        system.cardStack.align();
    });

    StreakBar.instance
        .updatePromise(system.store.getState().levelState.cardsState.turns)
        .then(() => {
            system.taskQueue.queueNext(task);
            system.startTasks();
        });
}
